import EA from 'helpers/init';
import Swiper from 'swiper';
import 'swiper/css';

export default EA.Methods.gallerySliderSmall = ($this) => {
    const slider = $this.querySelector('.swiper');

    new Swiper(slider, {
        speed: 1200,
        spaceBetween: 18,
        slidesPerView: 'auto',
        allowTouchMove: true,
        breakpoints: {
            769: {
                spaceBetween: 24
            }
        }
    });
};
